import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef, HostListener, EventEmitter, Output } from '@angular/core';
import { BaseComponent } from "../classes/BaseComponent";
import { Router } from "@angular/router";
import { Global } from "../classes/Global";
import { StorageHelper } from '../helpers/StorageHelper';
import { StringHelper } from '../helpers/StringHelper';
import { ThemeService } from '../theme.service';
import { CountryService } from '../country.service';
import { MediaIconHelper } from '../helpers/MediaIconHelper';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent extends BaseComponent implements OnInit, OnDestroy {

  /**
   * items must be an object with keys which are categories (here, the different medias: albums, movies,etc),
   * which contain the ojects (concrete movies, albums, etc.)
   */
  @Input() title: string;
  @Input() items;
  @ViewChild("carouselCategoryDiv", {static: false}) carouselCategoryDiv: ElementRef;
  @Output() onAddToWishlistClick = new EventEmitter<any>();
  @Output() onAddToBlocklistClick = new EventEmitter<any>();
  @Output() onAddToOwnlistClick = new EventEmitter<any>();
  @Output() onRemoveFromWishlistClick = new EventEmitter<any>();
  @Output() onRemoveFromOwnlistClick = new EventEmitter<any>();
  categories: Array<any> = [];
  carouselMarginLeft = 0;
  carouselPosition = 0;
  interval;
  resizeTimeout;
  slideTimeout;
  showMoreDiv = true;

  moreOffersURL = "";

  constructor(
    private router: Router,
    private themeService: ThemeService,
    private countryService: CountryService
  ) {
    super();
  }


  ngOnDestroy(): void {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    if (this.slideTimeout) {
      clearTimeout(this.slideTimeout);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event){
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => { this.doneResizing(this); }, 250);
  }

  doneResizing(self: any) {
    //Reslide the carousel to be at the right place after resizing
    //This recalculates the right scroll value to be at
    this.slide(1);
    this.slide(-1);

    //The carousel must not slide automatically on mobile
    if (window.innerWidth < 1200){
      self.stopInterval();
    }
    else {
      self.startInterval();
    }
  }

  ngOnInit() {
    this.categories = Object.keys(this.items);
    let mediaType = this.categories[this.carouselPosition];
    if (mediaType == "movies") {
      mediaType = "buymovies";
    }
    this.moreOffersURL = this.getMoreOffersUrl();
    StorageHelper.getInstance().save(StorageHelper.keys.mediaType, mediaType);
    this.startInterval();
  }

  startInterval(){
    // Remove the automatic sliding
    // if(window.innerWidth >= 1200){
    //   clearInterval(this.interval);
    //   this.interval = setInterval(() => { this.slide(1) }, 5000);
    // }
  }

  stopInterval(){
    if(this.interval) {
      clearInterval(this.interval);
    }
  }

  slide(steps: number){
    if (!this.carouselCategoryDiv || !this.carouselCategoryDiv.nativeElement) {
      return;
    }

    //hide mode-div for an instant, to let time to the carousel to scroll
    this.showMoreDiv = false;
    //show it after it has finished scrolling. 700ms are set in the css animation
    if (this.slideTimeout) {
      clearTimeout(this.slideTimeout);
    }
    this.slideTimeout = setTimeout(() => {
      this.showMoreDiv = true;
    }, 800);

    //calculate new Carousel position
    this.carouselPosition += steps;
    const m = Object.keys(this.items).length;
    this.carouselPosition = ((this.carouselPosition % m) + m) % m;

    //Apply the margin-left accordingly
    this.carouselMarginLeft = (-this.carouselPosition * this.carouselCategoryDiv.nativeElement.offsetWidth);

  }

  getItunesIconSrc(): string {
    return "./assets/images/store-icons/apple-tv.png";
  }

  getAmazonSrc(): string {
    return "./assets/images/store-icons/prime-video.png";
  }

  getGooglePlaySrc(): string {
    return "./assets/images/store-icons/google-play.png";
  }

  getVuduSrc(): string {
    return "./assets/images/store-icons/fandango.png";
  }

  mediaChanged(mediaType){
    this.stopInterval();

    let tmp = mediaType;
    if (tmp == "movies") {
      tmp = "buymovies";
    }
    StorageHelper.getInstance().save(StorageHelper.keys.mediaType, tmp);

    const index = this.categories.indexOf(mediaType);
    if (index != -1){
      const distanceToSlide = index - this.carouselPosition;
      this.slide(distanceToSlide);
      this.moreOffersURL = this.getMoreOffersUrl();
    }
  }

  addToWishlist(item) {
    this.onAddToWishlistClick.emit(item);
  }

  addToBlocklist(item) {
    this.onAddToBlocklistClick.emit(item);
  }

  addToOwnlist(item) {
    this.onAddToOwnlistClick.emit(item);
  }

  removeFromWishlist(item) {
    this.onRemoveFromWishlistClick.emit(item);
  }

  removeFromOwnlist(item) {
    this.onRemoveFromOwnlistClick.emit(item);
  }

  containsCategory(category: string): boolean {
    return this.categories.indexOf(category) > -1;
  }

  isActiveCategory(category: string): boolean {
    return this.categories[this.carouselPosition] == category;
  }

  getMaterialIcon(mediaType: string): string {
    return MediaIconHelper.getMaterialIcon(mediaType);
  }

  getMoreOffersUrl(): string {
    let mediaType = this.categories[this.carouselPosition];
    let store = this.titleToStore;
    if(store == Global.GOOGLEPLAY) {
      store = "google-play";
    }
    return "/" + Global.getCountry() + "/" + store + "/" + this.getString(mediaType + 'Url') + "/" + this.getString('onSaleUrl');
  }

  getMoreDivClass(index: number): string {
    let moreDivClass = "more-div";
    if (this.showMoreDiv && index == this.carouselPosition) {
      moreDivClass += " visibility-visible";
    }
    else {
      moreDivClass += " visibility-hidden";
    }
    return moreDivClass;
  }

  getMediaIconAlt(mediaStringKey: string): string {
    return StringHelper.format(this.getString('mediaDeals'), this.getString(mediaStringKey));
  }

  getCarouselTitle(): string {
    if (this.title === 'itunes') {
      return 'Apple TV';
    }
    if (this.title === 'vudu' && this.countryService.getCountry() === 'us') {
      return 'Fandango at Home';
    }
    if (this.title === 'amazonPrimeVideo') {
      return 'Prime Video';
    }
    return this.getString(this.title);
  }

  get titleToStore(): string {
    let store = this.title;
    if(store == "amazonPrimeVideo") {
      store = Global.AMAZON;
    }
    return store;
  }

}
